/**
 * @description 菜单管理 menuManage
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const menuManageBiz = new Logic()

menuManageBiz.getAll = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.menuManage.getAll,
    data: data
  })
}

menuManageBiz.findOneMenu = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.menuManage.findOneMenu,
    data: data
  })
}

menuManageBiz.addMenu = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.menuManage.addMenu,
    data: data
  })
}

menuManageBiz.deleteMenu = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.menuManage.deleteMenu,
    data: data
  })
}

menuManageBiz.getUserMenu = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.menuManage.getUserMenu,
    data: data
  })
}

menuManageBiz.updateMenu = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.menuManage.updateMenu,
    data: data
  })
}

export default menuManageBiz
